export const pageStyle = {
  paddingLeft: 20,
  paddingRight: 20,
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
};
